import { useState } from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/system';

import { Text } from 'ui';
import palette from 'ui/theme/palette';
import { maskValue } from './util/mask-value';

interface Props {
  color?: string;
  dataCy?: string;
  label: string;
  noBottomMargin?: boolean;
  value: string | React.ReactNode;
  mask?: boolean;
  labelPrimary?: boolean;
}

export const LabelValue: React.FC<Props> = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });

  const [revealMask, setRevealMask] = useState<boolean>(false);

  return (
    <Box sx={{ marginBottom: props.noBottomMargin ? '0px' : '16px' }} data-cy={props.dataCy}>
      <Text
        type={isMobile ? 'body4' : 'body3'}
        sx={{
          fontWeight: 'bold',
          lineHeight: '15px',
          color: props.labelPrimary ? palette.text.primary : palette.text.secondary,
          marginBottom: '10px'
        }}
        content={props.label}
      />
      <Box sx={{ display: 'flex' }}>
        {typeof props.value === 'string' ? (
          <Text
            type={isMobile ? 'body3' : 'body1'}
            sx={{ lineHeight: '20px', color: props.color ? props.color : undefined }}
            content={revealMask ? props.value : maskValue(props.mask, props.value)}
          />
        ) : (
          props.value
        )}
        {props.mask && typeof props.value === 'string' && (props.value !== '--' || props.value.length >= 4) && (
          <Box sx={{ marginLeft: theme.spacing(1), marginTop: '1px', cursor: 'pointer' }}>
            {revealMask ? (
              <VisibilityOff
                onClick={() => {
                  setRevealMask(false);
                }}
              />
            ) : (
              <Visibility
                onClick={() => {
                  setRevealMask(true);
                }}
              />
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
};
